import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ProjectConfiguration from './projectConfiguration';
import { createProjectConfig,getProjectConfig } from 'services/redux/installation/projectCongifuration/action';

const mapStateToProps = (state) => ({
  projectDetails: state.projectConfigurationReducer.projectDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
          createProjectConfig,
          getProjectConfig
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(ProjectConfiguration);